import { createSelector } from 'reselect';
import { RootState } from '../reducers/root-reducer';
import { FormFieldsState } from '../reducers/form-fields/form-fields.reducer';

const getFormFieldsState = (state: RootState): FormFieldsState =>
  state.formFieldState;

const getAreFieldsLoading = createSelector(
  getFormFieldsState,
  (fieldState) => fieldState.isLoading
);

const getReasons = createSelector(
  getFormFieldsState,
  (fieldsState) => fieldsState.reasons
);

const getAllFields = createSelector(
  getFormFieldsState,
  (fieldsState) => fieldsState.fields
);

const getFieldValue = createSelector(
  getFormFieldsState,
  (fieldState) => (name: string): string => fieldState.fieldsValues[name]?.value
);
const getReasonsTags = createSelector(getFormFieldsState, (fieldState) => ({
  caseReasonTag: fieldState.fieldsValues.case_reason?.faq_tag,
  caseDetailedReasonTag: fieldState.fieldsValues.case_detailed_reason?.faq_tag
}));

const getErrorMessage = createSelector(
  getFormFieldsState,
  (fieldState) => fieldState.error
);

const getAttachmentVisible = createSelector(
  getAllFields,
  (fields) => fields?.attachment?.label
);

const getIsRedirectedFromClients = createSelector(
  getFormFieldsState,
  (fieldsState) => fieldsState.redirectedFromClients
);

const formFieldsSelectors = {
  getAreFieldsLoading,
  getAllFields,
  getReasons,
  getFieldValue,
  getReasonsTags,
  getErrorMessage,
  getAttachmentVisible,
  getIsRedirectedFromClients
};

export default formFieldsSelectors;
